import * as React from "react";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";

import BenefitPlanGrid from "./BenefitPlanGrid";

import { useQueryGetPlanDetailsPage } from "../../data/services/benefitPlanService";

const BenefitPlanLayout = () => {
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);

  const [offerType, setOfferType] = React.useState("MED");
  const [state, setState] = React.useState({ page: 1, size: 20, sort: [] });

  const { isFetching: planDetailPageLoading, data: planDetailPage } =
    useQueryGetPlanDetailsPage(state.page, state.size, offerType, state.sort);

  const handleStateChange = (newPage, newSize, newSort) => {
    setState({ page: newPage, size: newSize, sort: newSort });
  };

  const handleTabSelect = (e) => {
    setSelectedTabIndex(e.selected);
    handleStateChange(1, 20, state.sort);
    switch (e.selected) {
      default:
      case 0:
        setOfferType("MED");
        break;
      case 1:
        setOfferType("DEN");
        break;
      case 2:
        setOfferType("VIS");
        break;
    }
  };

  return (
    <TabStrip
      selected={selectedTabIndex}
      onSelect={handleTabSelect}
      style={{ paddingTop: 20 }}
    >
      <TabStripTab title="Medical Plans">
        <BenefitPlanGrid
          title={"Medical Plans"}
          page={state.page}
          size={state.size}
          sort={state.sort}
          planPage={planDetailPage?.data}
          onStateChange={handleStateChange}
          loading={planDetailPageLoading}
        />
      </TabStripTab>
      <TabStripTab title="Dental Plans">
        <BenefitPlanGrid
          title={"Dental Plans"}
          page={state.page}
          size={state.size}
          sort={state.sort}
          planPage={planDetailPage?.data}
          onStateChange={handleStateChange}
          loading={planDetailPageLoading}
        />
      </TabStripTab>
      <TabStripTab title="Vision Plans">
        <BenefitPlanGrid
          title={"Vision Plans"}
          page={state.page}
          size={state.size}
          sort={state.sort}
          planPage={planDetailPage?.data}
          onStateChange={handleStateChange}
          loading={planDetailPageLoading}
        />
      </TabStripTab>
    </TabStrip>
  );
};

export default BenefitPlanLayout;
